import { getProduct, optionLines, slotLines, unitPrice } from "@/lib/catalog";
import { activePhrases, resolvePhrase } from "@/lib/phrases";

// Partilhar o carrinho: a cliente envia um link à Alexandra, que o abre no painel e regista a encomenda.
// O carrinho vai dentro do próprio link (nada fica guardado em servidor). Chaves curtas para o link não ficar enorme.

const toB64 = (s) => {
  const bytes = new TextEncoder().encode(s);
  let bin = "";
  bytes.forEach((b) => { bin += String.fromCharCode(b); });
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};
const fromB64 = (c) => {
  const bin = atob(c.replace(/-/g, "+").replace(/_/g, "/"));
  return new TextDecoder().decode(Uint8Array.from(bin, (ch) => ch.charCodeAt(0)));
};
const clean = (o) => Object.fromEntries(Object.entries(o).filter(([, v]) => v !== null && v !== undefined && v !== "" && !(typeof v === "object" && !Object.keys(v).length)));

export const encodeCart = (items) =>
  toB64(JSON.stringify(items.map((i) => clean({
    s: i.slug, p: i.patternId, q: i.qty, n: i.personalization, z: i.zone, b: i.babyCm, c: i.note,
    h: i.phrase ? clean({ o: i.phrase.optionId, a: i.phrase.articleId, n: i.phrase.name }) : null,
    o: i.options ? Object.fromEntries(Object.entries(i.options).map(([k, v]) => [k, [v.choiceId, v.text ?? ""]])) : null,
    l: i.slots ? Object.fromEntries(Object.entries(i.slots).map(([k, v]) => [k, [v.modelId ?? "", v.patternId ?? ""]])) : null,
  }))));

// Devolve as linhas no formato do carrinho, só com as peças que ainda existem no catálogo. Código inválido → [].
export const decodeCart = (code) => {
  try {
    if (String(code).length > 12000) return [];
    const list = JSON.parse(fromB64(String(code)));
    if (!Array.isArray(list)) return [];
    return list.filter((r) => r && getProduct(r.s) && Number.isInteger(r.q) && r.q >= 1 && r.q <= 20).slice(0, 40).map((r) => ({
      slug: r.s, patternId: r.p ?? null, qty: r.q, personalization: r.n ?? null, zone: r.z ?? null, babyCm: r.b ?? null, note: r.c ?? null,
      phrase: r.h ? { optionId: r.h.o, articleId: r.h.a ?? null, name: r.h.n ?? "" } : null,
      options: r.o ? Object.fromEntries(Object.entries(r.o).map(([k, v]) => [k, { choiceId: v[0], text: v[1] ?? "" }])) : null,
      slots: r.l ? Object.fromEntries(Object.entries(r.l).map(([k, v]) => [k, { modelId: v[0] || null, patternId: v[1] || null }])) : null,
    }));
  } catch {
    return [];
  }
};

export const shareUrl = (items) => `${window.location.origin}/admin/encomendas/nova?carrinho=${encodeCart(items)}`;

// Pormenores da peça que o registo manual não tem em campos próprios (frase, opções, comentário...), em texto para as notas.
export const itemDetails = (i) => {
  const product = getProduct(i.slug);
  const phrases = activePhrases(product);
  const phrase = phrases && i.phrase ? resolvePhrase(phrases, i.phrase)?.phrase?.text : null;
  const zone = product?.personalization?.zones?.find((z) => z.id === i.zone)?.label;
  const parts = [
    phrase && `texto do saquinho: ${phrase}`,
    i.personalization && zone && `nome na zona: ${zone}`,
    ...optionLines(product, i.options).map((o) => `${o.label}: ${o.value}`),
    i.babyCm && `medida do bebé: ${i.babyCm} cm`,
    i.note && `comentário: ${i.note}`,
  ].filter(Boolean);
  return parts.length ? `${i.qty}x ${product.name} (${parts.join("; ")})` : "";
};

export const cartPrice = (i) => unitPrice(getProduct(i.slug), i.options, i.personalization);
export const cartSlotLines = (i) => slotLines(getProduct(i.slug), i.slots);
